!<template>
  <div class="useDetails"  ref="scrollContainer">
    <div class="fixTop van-hairline--bottom">
        <search-filter-new>
            <date-range-filter
                class="justify-left"
                :start="params.commentStartTime | formatDatetime('yyyy-MM-dd')"
                :end="params.commentEndTime | formatDatetime('yyyy-MM-dd')"
                @clickDate="chooseCalendar"
            />
        </search-filter-new>
    </div>
    <div class="content">
        <vx-list
            class="student-list-nav"
            enable
            :api="$api.findTokenUsageDetailList"
            :params="computeParams"
            :pageSize="15"
            @load="onLoad"
            firstShowLoading
            ref="vxList"
        >
            <div class="student-item-wrapper">
                <div class="tableList" >
                    <div class="listItem van-hairline--bottom" v-for="ite in list" :key="ite.operationTime">
                        <span class="time">{{ ite.name }}</span>
                        <span class="num" @click.stop="scrollTo">-{{ ite.value }}</span>
                    </div>
                </div>
            </div>
            <empty-page :show="list.length === 0 && !loading" tips="暂时还没有数据哦~" />
        </vx-list>
    </div>
    
    <!-- <div class="content"> -->
        <!-- <vx-list
            class="student-list-nav"
            enable
            :api="$api.studentListList"
            :params="computeParams"
            :pageSize="15"
            @load="onLoad"
            firstShowLoading
            ref="vxList"
        >
            <div class="student-item-wrapper">
                <div class="tableList" >
                    <div class="listItem van-hairline--bottom" v-for="list in 15" :key="list">
                        <span class="time">2023-12-05</span>
                        <span class="num" @click.stop="scrollTo">-2314</span>
                    </div>
                </div>
            </div>
            <empty-page :show="list.length === 0 && !loading" tips="没有找到学员~" />
        </vx-list> -->
        <!-- <div class="tableList" >
            <div class="listItem van-hairline--bottom" v-for="list in 15" :key="list">
                <span class="time">2023-12-05</span>
                <span class="num" @click.stop="scrollTo">-2314</span>
            </div>
        </div> -->
    <!-- </div> -->
  </div>
</template>

<script>
import SearchFilterNew from '@x3/vue/comp/search-filter-new.vue';
import dateRangeFilter from '@x3/vue/filter-comps/date-range-filter.vue';
import emptyPage from '@teacher/components/empty-page.vue';
const startTime = app.tool.date.formatDatetime(new Date().getTime() - 518400000, 'yyyy-MM-dd')
const endTime = app.tool.date.formatDatetime(new Date().getTime(), 'yyyy-MM-dd')
export default {
    components: {
        SearchFilterNew,
        dateRangeFilter,
        emptyPage
    },
    data() {
        return {
            pageTitle: '使用明细',
            params: {
                commentStartTime: new Date(app.tool.date.getDelayDay(-6)), //最近7天
                commentEndTime: new Date(),
            },
            customLoaded: false,
            list: [],
            totalCount: 0,
            loading: true,
            computeParams: {
                "endTime": endTime,
                'startTime': startTime,
            },
        }
    },
    methods: {
        changeYear(date) {
            // let date = new Date(timestamp);
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            month = month < 10 ? `0${month}` : month
            let day = date.getDate();
            day = day < 10 ? `0${day}` : day
            return `${year}-${month}-${day}`;
        },
        onLoad(list, res) {
            list = list.map(v => {
                return { name: this.changeYear(new Date(v.operationTime)), value: v.tokenUsageNum, operationTime: v.operationTime }
            })
            this.list = list;
            this.totalCount = res.page.totalCount;
            this.loading = false;
        },
        scrollTo() {
            this.$refs.scrollContainer.scrollTop = 0;
        },
        chooseCalendar() {
            // 获取当前日期
            let currentDate = new Date();
             // 将当前日期减去一年
            currentDate.setFullYear(currentDate.getFullYear() - 1);
            app.x3.picker.dateRange({
                startDate: this.params.commentStartTime,
                endDate: this.params.commentEndTime,
                attrs: {
                    maxDate: new Date(),
                    minDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()),
                }
            })
            .then(res => {
                console.log(res)
                const { startDate, endDate } = res
                Object.assign(this.params, {commentStartTime: startDate, commentEndTime: endDate});
                Object.assign(this.computeParams, {startTime: this.changeYear(startDate), endTime: this.changeYear(endDate)});
                this.$refs['vxList'] && this.$refs['vxList'].refresh();
            })
            .catch(()=>{
                console.log('取消选择或报错了')
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.useDetails {
    .student-list-nav {
        flex: 1;
        position: static;
    }
    .fixTop {
        width: 100%;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 111;
        border-bottom: 1px solid var(--g3);
    }
    .content {
        .tableList {
            margin-top: calc(var(--gap) * 45);
            padding: 0 calc(var(--gap) * 16);;
            background: var(--white);
            .listItem {
                height: calc(var(--gap) * 54);;
                background: var(--white);
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-family: PingFang SC, PingFang SC;
                .time {
                    font-size: 14px;
                    font-weight: 400;
                    color: var(--g7);
                }
                .num {
                    font-size: 16px;
                    font-weight: 500;
                    color: var(--c1);
                }
                &:last-of-type {
                    border-bottom: 0;
                }
            }
        }
    }
}
</style>